import { Injectable } from '@angular/core';
import { SyncCryptService } from '../../../core/crypt/sync-crypt.service';
import { IDownloadMethod, ITransferItemDownload, IStoreData } from 'src/sync';
import { DownloadChunkFetchOptions, DownloadChunkFetchService } from './download-chunk-fetch.service';

@Injectable({
  providedIn: 'root',
})
export class DownloadLegacyService implements IDownloadMethod {
  constructor(
    private crypt: SyncCryptService,
    private downloadChunkFetch: DownloadChunkFetchService,
  ) {}

  public abort(): void {
    // no-op: legacy download does not support abort
  }

  public async getChunk(
    tItem: ITransferItemDownload,
    offset: number,
    reqLength: number,
    retry = 0,
    options?: DownloadChunkFetchOptions,
  ): Promise<IStoreData> {
    const respBuffer = await this.downloadChunkFetch.fetchChunk(tItem, offset, reqLength, retry, options);
    const processData: ChunkProcessData = {
      buffer: respBuffer,
      byteLen: respBuffer.byteLength,
      bytearray: [],
      datakey: tItem.data_key,
      packetAmt: Math.ceil(respBuffer.byteLength / this.crypt.GCM_PACKET_SIZE),
      sliceStart: 0,
      sliceEnd: respBuffer.byteLength > this.crypt.GCM_PACKET_SIZE ? this.crypt.GCM_PACKET_SIZE : respBuffer.byteLength,
      cryptOffset: offset,
      iterations: 0,
    };
    const result = await this.processPackets(processData);

    return {
      tItem: tItem,
      bytearray: result.bytearray,
      offset: offset,
      reqlength: reqLength,
      chunkLength: result.byteLen,
    };
  }
  public completed(): void {
    // no-op: no cleanup needed for legacy downloads
  }

  private async processPackets(data: ChunkProcessData): Promise<ChunkProcessData> {
    while (data.iterations < data.packetAmt) {
      data.iterations++;
      const crypted = data.buffer.slice(data.sliceStart, data.sliceEnd);
      const decryptedBuffer = await this.crypt.filedataDecrypt(new Uint8Array(crypted), data.datakey, data.cryptOffset);

      data.bytearray = data.bytearray.concat(<number[]>decryptedBuffer);
      data.sliceStart += this.crypt.GCM_PACKET_SIZE;
      data.sliceEnd =
        data.byteLen - data.sliceStart > this.crypt.GCM_PACKET_SIZE
          ? data.sliceEnd + this.crypt.GCM_PACKET_SIZE
          : data.sliceEnd + data.byteLen - data.sliceStart;
      data.cryptOffset += this.crypt.GCM_PACKET_SIZE;
    }
    return data;
  }
}

export interface ChunkProcessData {
  buffer: ArrayBuffer;
  datakey: ArrayLike<number>;
  byteLen: number;
  packetAmt: number;
  sliceStart: number;
  sliceEnd: number;
  cryptOffset: number;
  bytearray: number[];
  iterations: 0;
}
